import Component from 'component';
import _template from 'lodash/template';
import importComponent, {
  render
} from '../helpers/bootstrap';
import 'form-serializer';

class ReviewModal extends Component {
  constructor(el) {
    super(el);
    this.endpoint = this.$el.data('endpoint');
  }

  getContent() {
    //call templating of modal form
    const reviewsTpl = $('#modalSubmission').html();
    const templateFn = _template(reviewsTpl);

    const contentHTML = templateFn();
    this.content = {
      content: contentHTML
    }
    return this.content;
  }
  initModalContent() {
    this.dom.modal = $('#modal');
    this.dom.modal.addClass('modal--review');
    //init validation
    this.dom.$form = $('form', '#modal');
    this.dom.$file = this.dom.$form.find('input[type="file"]');
    this.fileReader = new FileReader();
    this.fileStr = '';
    importComponent('FormValidate', this.dom.$form)
      .then(data => {
        if (!data) return;
        const {
          component,
          el
        } = data;
        render(el, $target => new component($target));
      });

    //Init File Field
    importComponent('FileField', $('.js-file-field', this.dom.$form))
      .then(data => {
        if (!data) return;
        const {
          component,
          el
        } = data;
        render(el, $target => new component($target));
      });
    importComponent('CustomFormSelection', $('.js-select2', this.dom.$form))
      .then(data => {
        if (!data) return;
        const {
          component,
          el
        } = data;

        render(el, $target => new component($target, {
          minimumResultsForSearch: -1,
          dropdownParent: $('#modal')
        }));
      });
    //Listeners
    this.dom.$file.on('change', ::this.onFileSelect);
    //init submit
    this.dom.$form.on('submit', ::this.onReviewSubmit);
  }
  onFileSelect(e) {
    if (this.dom.$file[0].files.length > 0) {
      const file = this.dom.$file[0].files[0];
      this.fileReader.readAsDataURL(file);
    }
  }

  onReviewSubmit(e) {
    e.stopPropagation();
    e.preventDefault();
    if (this.dom.$form.valid()) {
      this.submitReview().catch(err => {
        console.log('Server error: ', err);
      });
    }
  }

  async submitReview() {
    if (!this.validateReviewData()) {
      this.displayFormLevelError('Please enter valid data in required fields.');
      return;
    }
    const res = await this.postReview()

    this.clearFormLevelError();

    if (res.success) {
      $('.modal-review__form-wrapper', '#modal').html(`<h2 class="modal-review__title"> ${res.response.title} </h2><div class="modal-review__subtitlen rtf-content-block"> ${res.response.message}</div>`);
    } else {
      this.displayFormLevelError('Invalid review data');
    }
  }

  validateReviewData() {
    const formData = this.dom.$form.serializeObject();
    if (
      formData.firstName && formData.firstName.trim() !== '' &&
      formData.lastName && formData.lastName.trim() !== '' &&
      formData.email && formData.email.trim() !== '' &&
      formData.city && formData.city.trim() !== '' &&
      formData.message && formData.message.trim() !== ''
    ) {
      return true;
    }
    return false;
  }

  clearFormLevelError() {
    $('.form__global-error', '#modal').html('');
  }

  displayFormLevelError(errorMessage) {
    $('.form__global-error', '#modal').html(`<p> ${errorMessage}</p>`);
  }

  postReview() {
    const formData = this.dom.$form.serializeObject();

    if (this.fileReader.result !== null && this.fileReader.result !== '') {
      formData.image = this.fileReader.result;
    }
    const data = JSON.stringify(formData);
    return $.ajax({
      method: 'POST',
      url: this.endpoint,
      contentType: 'application/json',
      data
    })

  }

  getB64Str(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for(let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}

export default ReviewModal;



// WEBPACK FOOTER //
// ./src/btu/js/components/ReviewModal.js